<template>
  <div class="container pt-lg-md" style="display: flex; justify-content: center;">
    <div class="row justify-content-center col-lg-5">
      <card type="secondary" shadow header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5" class="border-0" style="width: 100%;">
        <div class="text-center text-muted mb-4">
          <small>Шинэ нууц үгээ оруулна уу</small>
        </div>
        <form>
          <!-- Honeypot Field (Hidden) -->
          <input type="text" v-model="honeypot" style="display: none;" />

          <!-- New Password -->
          <base-input 
            alternative 
            v-model="password" 
            type="password" 
            placeholder="Шинэ нууц үг" 
            addon-left-icon="ni ni-lock-circle-open" 
            @input="validateField('password')"
          />
          <span v-if="errors.password" class="text-danger">{{ errors.password }}</span>

          <!-- Confirm Password -->
          <base-input 
            alternative 
            v-model="confirmPassword" 
            type="password" 
            placeholder="Нууц үг баталгаажуулах" 
            addon-left-icon="ni ni-lock-circle-open" 
            @input="validateField('confirmPassword')"
          />
          <span v-if="errors.confirmPassword" class="text-danger">{{ errors.confirmPassword }}</span>

          <!-- Error Message -->
          <div v-if="errorMessage" class="text-danger text-center mt-3">
            {{ errorMessage }}
          </div>

          <!-- Success Message -->
          <div v-if="successMessage" class="text-success text-center mt-3">
            {{ successMessage }}
          </div>

          <!-- Submit Button -->
          <div class="text-center">
            <base-button 
              :loading="loading" 
              type="button" 
              class="btn my-4 btn-primary" 
              @click="submitResetPassword"
              :disabled="loading || cooldownActive"
            >
              {{ loading ? 'Сэргээж байна...' : 'Нууц үг сэргээх' }}
            </base-button>
          </div>
        </form>
      </card>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

export default {
  data() {
    return {
      token: '',
      password: '',
      confirmPassword: '',
      loading: false,
      errorMessage: '',
      successMessage: '',
      cooldownActive: false, // Prevent rapid submissions
      honeypot: '', // For spam bot detection
      errors: {
        password: '',
        confirmPassword: ''
      }
    };
  },
  
  mounted() {
    // URL-ээс токеныг авах
    this.token = this.$route.query.token;
    if (!this.token) {
      this.errorMessage = 'Токен алга эсвэл буруу байна.';
    }
  },

  methods: {
    validateField(field) {
      this.errors[field] = '';

      switch (field) {
        case 'password':
          if (!this.password) {
            this.errors.password = 'Нууц үг оруулна уу';
          } else if (this.password.length < 8) {
            this.errors.password = 'Нууц үг хамгийн багадаа 8 тэмдэгт байх ёстой';
          } else if (!/[A-Z]/.test(this.password)) {
            this.errors.password = 'Нууц үг дор хаяж нэг том үсэг агуулсан байх ёстой';
          } else if (!/[0-9]/.test(this.password)) {
            this.errors.password = 'Нууц үг дор хаяж нэг тоо агуулсан байх ёстой';
          }
          break;

        case 'confirmPassword':
          if (!this.confirmPassword) {
            this.errors.confirmPassword = 'Нууц үг баталгаажуулна уу';
          } else if (this.confirmPassword !== this.password) {
            this.errors.confirmPassword = 'Нууц үг таарахгүй байна';
          }
          break;
      }
    },

    validateForm() {
      this.validateField('password');
      this.validateField('confirmPassword');

      return !this.errors.password && !this.errors.confirmPassword;
    },

    async submitResetPassword() {
      // Prevent spam via cooldown
      if (this.loading || this.cooldownActive) return;

      // Honeypot Protection
      if (this.honeypot) {
        console.warn("Spam attempt detected");
        this.errorMessage = "Алдаа гарлаа. Дахин оролдоно уу.";
        return;
      }

      if (!this.validateForm()) return;

      this.loading = true;
      this.errorMessage = '';
      this.successMessage = '';

      try {
        const response = await axios.post('/reset-password', {
          token: this.token,
          password: this.password
        });

        this.successMessage = response.data.message;

        // Redirect after success
        setTimeout(() => {
          this.$router.push('/login');
        }, 2000);
        
        // Start cooldown after success
        this.startCooldown();

      } catch (error) {
        console.error('Алдаа:', error.response);
        this.errorMessage = error.response.data.detail || 'Алдаа гарлаа. Дахин оролдоно уу.';
      } finally {
        this.loading = false;
      }
    },

    startCooldown() {
      this.cooldownActive = true;

      // Cooldown for 10 seconds to prevent spam
      setTimeout(() => {
        this.cooldownActive = false;
      }, 10000); // 10 seconds
    }
  }
};
</script>

<style scoped>
.text-danger {
  font-size: 14px;
}

.text-success {
  font-size: 14px;
}

.base-button[disabled] {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>
